import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cec77d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tools h-full bg-primary-50" }
const _hoisted_2 = { class: "left-panel sidebar fixed overflow-hidden" }
const _hoisted_3 = { class: "w-full text-right" }
const _hoisted_4 = { class: "searchbar flex" }
const _hoisted_5 = { class: "list h-full overflow-auto" }
const _hoisted_6 = { class: "inline-block align-middle name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button bg-white text-primary cursor-pointer" }, "Vedi", -1))
const _hoisted_8 = { class: "see-more" }
const _hoisted_9 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AddNewToolModalDialog = _resolveComponent("AddNewToolModalDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PrimaryButton, {
          class: "bg-primary-900 text-white",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingAddNewToolDialog = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Aggiungi tipologia strumento")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "text px-4 py-3 flex-grow",
          type: "text",
          placeholder: "Cerca tipologia di strumento",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.searchQuery]
        ]),
        _createVNode(_component_PrimaryButton, {
          class: "button bg-white text-primary flex-none",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cerca")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tools, (tool, i) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            class: "link bg-white text-black justify-between flex flex-row font-bold align-middle focus:outline-none focus:shadow-outline",
            key: tool.id,
            to: `/tools/${tool.id}`,
            type: "button"
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_6, _toDisplayString(tool.name), 1),
              _hoisted_7
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h2", {
            class: "font-bold text-center cursor-pointer",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.paginate()))
          }, "Carica altre tipologie di strumenti")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "slide-fade",
            mode: "in-out"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    (_ctx.isShowingAddNewToolDialog)
      ? (_openBlock(), _createBlock(_component_AddNewToolModalDialog, {
          key: 0,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowingAddNewToolDialog = false))
        }))
      : _createCommentVNode("", true)
  ]))
}